var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconsLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.192,
    height: 13.752,
    viewBox: "0 0 8.192 13.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.18-8.615a.516.516,0,0,0,0,.73L6.488-1.525a.516.516,0,0,0,.73,0l.851-.851a.516.516,0,0,0,0-.73L2.978-8.25,8.07-13.393a.516.516,0,0,0,0-.73l-.851-.851a.516.516,0,0,0-.73,0Z",
    transform: "translate(-0.029 15.126)",
    fill: "#1a1100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconsLeftArrow);
export default __webpack_public_path__ + "static/media/navigationIcons_LeftArrow.164b47c9.svg";
export { ForwardRef as ReactComponent };